var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "transparent",
    d: "M56.8486 20.0993C56.8486 30.9237 48.0689 39.6986 37.2385 39.6986C26.4082 39.6986 17.6284 30.9237 17.6284 20.0993C17.6284 9.27491 26.4082 0.5 37.2385 0.5C48.0689 0.5 56.8486 9.27491 56.8486 20.0993Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "transparent",
    d: "M66 54.8554C66 59.7108 56.8486 75.5 37.2385 75.5C18.4128 75.5 9 60 9 54.8554C9 50.4129 14.2294 43.0958 37.2385 43.0958C60.2477 43.0958 66 50 66 54.8554Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultAvatar);
export default __webpack_public_path__ + "static/media/default-avatar.2a6a241752599b679614bf7f9da4be7c.svg";
export { ForwardRef as ReactComponent };